var _path, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    id: "OBJECT",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26,25H19.77V23h-2v2h-4V23h-2v2H6a1,1,0,0,0,0,2H26a1,1,0,0,0,0-2Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "20.5 15 19.43 11 12.57 11 11.5 15 20.5 15"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "10.5 11 3.53 11 2.39 15 9.43 15 10.5 11"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "22.57 15 29.61 15 28.47 11 21.5 11 22.57 15"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "10.96 17 9.89 21 22.11 21 21.04 17 10.96 17"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "17.82 5 14.18 5 13.11 9 18.89 9 17.82 5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31,19.73,30.18,17H23.11l1.07,4H30a1,1,0,0,0,.8-.4A1,1,0,0,0,31,19.73Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9,9,27,5.73A1,1,0,0,0,26,5H19.89L21,9Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.89,17H1.82L1,19.73a1,1,0,0,0,.16.87A1,1,0,0,0,2,21H7.82Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.11,5H6a1,1,0,0,0-1,.73L4.1,9H11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon-1.3ed3ebfb64feb9cf66f17ffc9234e62f.svg";
export { ForwardRef as ReactComponent };